import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CreateOrganizationForm } from './-components/create-organization-form'

function AdminFullCreatePage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Full Create</h1>
        <p className="text-muted-foreground">Create a new organization with full configuration</p>
      </div>
      <CreateOrganizationForm
        onSuccess={() => navigate({ to: '/admin' })}
      />
    </div>
  )
}

export const Route = createFileRoute('/_authed/admin/create')({
  component: AdminFullCreatePage,
})
